// SavedFilterService - CRUD operations for saved filter presets
import { db } from './FishingDB';
import { SavedFilter } from '../entities/SavedFilter';
import { CatchFilters, getDefaultFilters } from '../entities/CatchesPageTypes';

/**
 * Get all saved filters, sorted by last used
 */
export async function getAllSavedFilters(): Promise<SavedFilter[]> {
  return await db.savedFilters.orderBy('lastUsed').reverse().toArray();
}

/**
 * Get a specific saved filter by ID
 */
export async function getSavedFilter(id: string): Promise<SavedFilter | undefined> {
  return await db.savedFilters.get(id);
}

/**
 * Create a new saved filter
 */
export async function createSavedFilter(
  name: string,
  filters: CatchFilters,
  icon?: string,
  color?: string
): Promise<string> {
  const now = Date.now();
  const id = `filter_${now}_${Math.random().toString(36).substr(2, 9)}`;
  
  const savedFilter: SavedFilter = {
    id,
    name,
    filters,
    icon,
    color,
    createdAt: now,
    lastUsed: now
  };
  
  await db.savedFilters.add(savedFilter);
  console.log('✅ Created saved filter:', name);
  return id;
}

/**
 * Update an existing saved filter
 */
export async function updateSavedFilter(
  id: string,
  updates: Partial<Omit<SavedFilter, 'id' | 'createdAt'>>
): Promise<void> {
  await db.savedFilters.update(id, updates);
  console.log('✅ Updated saved filter:', id);
}

/**
 * Update filter's lastUsed timestamp
 */
export async function markFilterAsUsed(id: string): Promise<void> {
  await db.savedFilters.update(id, { lastUsed: Date.now() });
}

/**
 * Delete a saved filter
 */
export async function deleteSavedFilter(id: string): Promise<void> {
  await db.savedFilters.delete(id);
  console.log('✅ Deleted saved filter:', id);
}

/**
 * Check if a filter name already exists (case-insensitive)
 */
export async function filterNameExists(name: string, excludeId?: string): Promise<boolean> {
  const filters = await db.savedFilters.toArray();
  return filters.some(f => 
    f.name.toLowerCase() === name.toLowerCase() && f.id !== excludeId
  );
}

/**
 * Get default "All Catches" filter
 */
export function getDefaultAllCatchesFilter(): CatchFilters {
  return getDefaultFilters();
}
